/* XPOWER - Ficha de producto. JavaScript nativo, sin jQuery ni librerias. */
(function () {
  'use strict';

  function init(raiz) {
    if (!raiz || raiz.dataset.xpReady === '1') return;
    raiz.dataset.xpReady = '1';

    var datos = {};
    var nodoDatos = raiz.querySelector('[data-xp-datos]');
    try { datos = JSON.parse(nodoDatos.textContent); } catch (e) { datos = { variantes: [] }; }
    var variantes = datos.variantes || [];
    var textos = datos.textos || {};
    var umbralBajo = parseInt(datos.stockBajo, 10) || 5;

    var form      = raiz.querySelector('[data-xp-form]');
    var inputId   = raiz.querySelector('[data-xp-id]');
    var cta       = raiz.querySelector('[data-xp-cta]');
    var precioNow = raiz.querySelector('[data-xp-precio]');
    var precioWas = raiz.querySelector('[data-xp-antes]');
    var precioSave= raiz.querySelector('[data-xp-ahorro]');
    var stockBox  = raiz.querySelector('[data-xp-stock]');
    var barra     = raiz.querySelector('[data-xp-barra]');
    var barraCta  = raiz.querySelector('[data-xp-barra-cta]');
    var barraP    = raiz.querySelector('[data-xp-barra-precio]');
    var barraImg  = raiz.querySelector('.xp-bar__img');
    var barraUrg  = null;
    var barraCerrada = false;

    /* ---------- TARJETA FIJA DE COMPRA ---------- */
    if (barra && !barra.querySelector('.xp-bar__fila')) {
      var fila = document.createElement('div');
      fila.className = 'xp-bar__fila';
      while (barra.firstChild) fila.appendChild(barra.firstChild);

      barraUrg = document.createElement('div');
      barraUrg.className = 'xp-bar__urg';
      barraUrg.hidden = true;

      var equis = document.createElement('button');
      equis.type = 'button';
      equis.className = 'xp-bar__x';
      equis.setAttribute('aria-label', 'Cerrar');
      equis.innerHTML = '&times;';
      equis.addEventListener('click', function () {
        barraCerrada = true;
        barra.classList.remove('is-on');
        setTimeout(function () { barra.classList.add('is-off'); }, 340);
      });

      barra.appendChild(equis);
      barra.appendChild(barraUrg);
      barra.appendChild(fila);
    }

    /* ---------- GALERIA ----------
       El tema carga nicescroll, que se apodera del scroll de los contenedores.
       Las fotos se mueven con transform, que nadie puede interceptar. */
    var pista  = raiz.querySelector('[data-xp-pista]');
    var slides = raiz.querySelectorAll('[data-xp-slide]');
    var thumbs = raiz.querySelectorAll('[data-xp-thumb]');
    var contador = raiz.querySelector('[data-xp-contador]');
    var carril = null;
    var indiceActual = 0;

    if (pista && slides.length) {
      carril = document.createElement('div');
      carril.className = 'xp-gal__track';
      for (var q = 0; q < slides.length; q++) carril.appendChild(slides[q]);
      pista.appendChild(carril);
      pista.classList.add('xp-gal--tx');
    }

    function fotoDeSlide(idx) {
      if (!slides[idx]) return null;
      var im = slides[idx].querySelector('img');
      if (!im) return null;
      return im.currentSrc || im.src || null;
    }

    function sincronizarBarra(idx) {
      if (!barraImg) return;
      var src = fotoDeSlide(idx);
      if (src && barraImg.src !== src) barraImg.src = src;
    }

    function marcarActivo(i) {
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].setAttribute('aria-current', t === i ? 'true' : 'false');
      }
      if (contador) contador.textContent = (i + 1) + ' / ' + slides.length;
      sincronizarBarra(i);
    }

    function irA(i, suave) {
      if (!carril || i < 0 || i >= slides.length) return;
      if (suave === false) carril.style.transition = 'none';
      carril.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (suave === false) {
        void carril.offsetWidth;
        carril.style.transition = '';
      }
      indiceActual = i;
      marcarActivo(i);
    }

    function indiceDeMedia(id) {
      for (var s = 0; s < slides.length; s++) {
        if (slides[s].getAttribute('data-media-id') === String(id)) return s;
      }
      return -1;
    }

    for (var t2 = 0; t2 < thumbs.length; t2++) {
      (function (idx) {
        thumbs[idx].addEventListener('click', function () { irA(idx); });
      })(t2);
    }

    if (pista && slides.length > 1) {
      var tocX = null, tocY = null;
      pista.addEventListener('touchstart', function (ev) {
        tocX = ev.touches[0].clientX;
        tocY = ev.touches[0].clientY;
      }, { passive: true });
      pista.addEventListener('touchend', function (ev) {
        if (tocX === null) return;
        var dx = ev.changedTouches[0].clientX - tocX;
        var dy = ev.changedTouches[0].clientY - tocY;
        tocX = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        var destino = indiceActual + (dx < 0 ? 1 : -1);
        if (destino < 0) destino = 0;
        if (destino > slides.length - 1) destino = slides.length - 1;
        irA(destino);
      }, { passive: true });
      marcarActivo(0);
    }

    /* ---------- VARIANTES ---------- */
    var grupos = raiz.querySelectorAll('[data-xp-grupo]');

    function esGrupoColor(g) { return !!(grupos[g] && grupos[g].querySelector('.xp-sw')); }

    function seleccionadas() {
      var vals = [];
      for (var g = 0; g < grupos.length; g++) {
        var marcado = grupos[g].querySelector('input:checked');
        vals.push(marcado ? marcado.value : null);
      }
      return vals;
    }

    function buscarVariante(vals) {
      for (var v = 0; v < variantes.length; v++) {
        var ok = true;
        for (var i = 0; i < vals.length; i++) {
          if (vals[i] === null || variantes[v].opciones[i] !== vals[i]) { ok = false; break; }
        }
        if (ok) return variantes[v];
      }
      return null;
    }

    function hayDisponible(gi, valor) {
      for (var v = 0; v < variantes.length; v++) {
        if (variantes[v].opciones[gi] === valor && variantes[v].disponible) return true;
      }
      return false;
    }

    function fotoDeValor(gi, valor) {
      for (var v = 0; v < variantes.length; v++) {
        if (variantes[v].opciones[gi] === valor && variantes[v].imagenId) return variantes[v].imagenId;
      }
      return null;
    }

    /* Los COLORES solo se tachan si no hay ninguna talla disponible de ese color.
       Las TALLAS se tachan segun el color elegido. Asi el cliente nunca cree
       que un color no existe solo porque tenia otra talla seleccionada. */
    function marcarAgotados(actuales) {
      for (var g = 0; g < grupos.length; g++) {
        var color = esGrupoColor(g);
        var entradas = grupos[g].querySelectorAll('input');
        for (var e = 0; e < entradas.length; e++) {
          var etiqueta = entradas[e].nextElementSibling;
          if (!etiqueta) continue;
          var ok;
          if (color) {
            ok = hayDisponible(g, entradas[e].value);
          } else {
            var prueba = actuales.slice();
            prueba[g] = entradas[e].value;
            var cand = buscarVariante(prueba);
            ok = !!(cand && cand.disponible);
          }
          etiqueta.classList.toggle('is-out', !ok);
        }
      }
    }

    /* Si el cliente elige un color que no existe en la talla que tenia marcada,
       se le cambia sola a la primera talla disponible de ese color. */
    function ajustarTalla(gi, valor) {
      var va = buscarVariante(seleccionadas());
      if (va && va.disponible) return;
      for (var v = 0; v < variantes.length; v++) {
        if (variantes[v].opciones[gi] === valor && variantes[v].disponible) {
          for (var g = 0; g < grupos.length; g++) {
            if (g === gi) continue;
            var entradas = grupos[g].querySelectorAll('input');
            for (var e = 0; e < entradas.length; e++) {
              if (entradas[e].value === variantes[v].opciones[g]) {
                entradas[e].checked = true;
                var et = grupos[g].querySelector('[data-xp-valor]');
                if (et) et.textContent = entradas[e].value;
              }
            }
          }
          return;
        }
      }
    }

    function singular(txt) {
      return txt
        .replace(/unidades/g, 'unidad').replace(/Unidades/g, 'Unidad')
        .replace(/quedan/g, 'queda').replace(/Quedan/g, 'Queda');
    }

    function esEscaso(va) {
      return !!(va && va.disponible && va.gestionaInventario && va.cantidad > 0 && va.cantidad <= umbralBajo);
    }

    function textoEscasez(va) {
      var txt = (textos.quedan || 'Ultimas unidades').replace('{n}', va.cantidad);
      return va.cantidad === 1 ? singular(txt) : txt;
    }

    function pintarUrgencia(va) {
      if (!barraUrg) return;
      if (esEscaso(va)) {
        barraUrg.textContent = '🔥 ' + textoEscasez(va);
        barraUrg.hidden = false;
      } else {
        barraUrg.hidden = true;
      }
    }

    function pintarStock(va) {
      pintarUrgencia(va);
      if (!stockBox) return;
      stockBox.className = 'xp-stock';
      if (!va || !va.disponible) {
        stockBox.classList.add('xp-stock--out');
        stockBox.innerHTML = '<span class="xp-stock__dot"></span>' + (textos.agotado || 'Agotado');
        return;
      }
      if (esEscaso(va)) {
        stockBox.classList.add('xp-stock--low');
        stockBox.innerHTML = '<span class="xp-stock__dot"></span>' + textoEscasez(va);
        return;
      }
      stockBox.innerHTML = '<span class="xp-stock__dot"></span>' + (textos.disponible || 'Disponible');
    }

    function volverAFotoElegida() {
      var va = buscarVariante(seleccionadas());
      if (va && va.imagenId) {
        var idx = indiceDeMedia(va.imagenId);
        if (idx >= 0) irA(idx, false);
      }
    }

    function actualizar() {
      var actuales = seleccionadas();
      marcarAgotados(actuales);
      var va = buscarVariante(actuales);

      if (!va) {
        if (cta) { cta.disabled = true; cta.textContent = textos.noDisponible || 'No disponible'; }
        if (barraCta) barraCta.disabled = true;
        pintarStock(null);
        return;
      }

      if (inputId) inputId.value = va.id;
      if (precioNow) precioNow.textContent = va.precio;
      if (barraP) barraP.textContent = va.precio;

      if (precioWas) {
        precioWas.textContent = va.antes || '';
        precioWas.style.display = va.antes ? '' : 'none';
      }
      if (precioSave) {
        precioSave.textContent = va.ahorroPct ? '-' + va.ahorroPct + '%' : '';
        precioSave.style.display = va.ahorroPct ? '' : 'none';
      }

      var puede = !!va.disponible;
      if (cta) {
        cta.disabled = !puede;
        cta.textContent = puede ? (textos.agregar || 'Agregar al carrito') : (textos.agotado || 'Agotado');
      }
      if (barraCta) barraCta.disabled = !puede;

      pintarStock(va);

      if (va.imagenId) {
        var idx = indiceDeMedia(va.imagenId);
        if (idx >= 0) irA(idx);
      }

      if (window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', va.id);
          history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }

    var entradas = raiz.querySelectorAll('[data-xp-grupo] input');
    for (var e2 = 0; e2 < entradas.length; e2++) {
      entradas[e2].addEventListener('change', function () {
        var grupo = this.closest('[data-xp-grupo]');
        if (grupo) {
          var et = grupo.querySelector('[data-xp-valor]');
          if (et) et.textContent = this.value;
          var gi = Array.prototype.indexOf.call(grupos, grupo);
          if (esGrupoColor(gi)) ajustarTalla(gi, this.value);
        }
        actualizar();
      });
    }

    /* ---------- VISTA PREVIA AL PASAR EL CURSOR ---------- */
    var conPuntero = window.matchMedia ? window.matchMedia('(hover: hover)').matches : false;
    if (conPuntero) {
      for (var g2 = 0; g2 < grupos.length; g2++) {
        (function (gi) {
          var circulos = grupos[gi].querySelectorAll('.xp-sw');
          for (var k = 0; k < circulos.length; k++) {
            (function (sw) {
              var entrada = sw.previousElementSibling;
              sw.addEventListener('mouseenter', function () {
                if (!entrada) return;
                var mid = fotoDeValor(gi, entrada.value);
                if (mid === null) return;
                var idx = indiceDeMedia(mid);
                if (idx >= 0) irA(idx);
              });
              sw.addEventListener('mouseleave', volverAFotoElegida);
            })(circulos[k]);
          }
        })(g2);
      }
    }

    /* ---------- CANTIDAD ---------- */
    var campoCant = raiz.querySelector('[data-xp-cantidad]');
    var botonesCant = raiz.querySelectorAll('[data-xp-paso]');
    for (var b = 0; b < botonesCant.length; b++) {
      botonesCant[b].addEventListener('click', function () {
        if (!campoCant) return;
        var actual = parseInt(campoCant.value, 10) || 1;
        var paso = parseInt(this.getAttribute('data-xp-paso'), 10);
        campoCant.value = Math.max(1, actual + paso);
      });
    }

    /* ---------- ACORDEON ---------- */
    var accBtns = raiz.querySelectorAll('[data-xp-acc]');
    for (var a = 0; a < accBtns.length; a++) {
      accBtns[a].addEventListener('click', function () {
        var abierto = this.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (panel) {
          panel.style.maxHeight = abierto ? '0px' : (panel.scrollHeight + 40) + 'px';
          if (!abierto) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    /* ---------- VENTANA EMERGENTE ---------- */
    var modales = raiz.querySelectorAll('[data-xp-modal]');
    for (var m = 0; m < modales.length; m++) {
      document.body.appendChild(modales[m]);
    }
    var ultimoFoco = null;
    function abrir(id) {
      var mod = document.getElementById(id);
      if (!mod) return;
      ultimoFoco = document.activeElement;
      mod.classList.add('is-on');
      document.documentElement.classList.add('xp-bloqueo');
      var x = mod.querySelector('[data-xp-cerrar]');
      if (x && x.focus) x.focus();
    }
    function cerrar(mod) {
      if (!mod) return;
      mod.classList.remove('is-on');
      document.documentElement.classList.remove('xp-bloqueo');
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }
    var abridores = raiz.querySelectorAll('[data-xp-abrir]');
    for (var ab = 0; ab < abridores.length; ab++) {
      (function (btn) {
        btn.addEventListener('click', function () { abrir(btn.getAttribute('data-xp-abrir')); });
      })(abridores[ab]);
    }
    document.addEventListener('click', function (ev) {
      var c = ev.target.closest ? ev.target.closest('[data-xp-cerrar]') : null;
      if (c) cerrar(c.closest('[data-xp-modal]'));
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') {
        var abierta = document.querySelector('[data-xp-modal].is-on');
        if (abierta) cerrar(abierta);
      }
    });

    /* ---------- APARICION DE LA TARJETA ---------- */
    if (barra && cta && 'IntersectionObserver' in window) {
      var vigia = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (barraCerrada) return;
          barra.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      vigia.observe(cta);
    }
    if (barraCta && form) {
      barraCta.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    actualizar();
    sincronizarBarra(indiceActual);
  }

  function arrancar() {
    var nodos = document.querySelectorAll('[data-xp-pdp]');
    for (var i = 0; i < nodos.length; i++) init(nodos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
